import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import {MemberService} from '../../services/member.service';
import {Router} from '@angular/router';
import {MemberStateService} from '../../services/member-state.service';
import {ValidationService} from '../../services/validation.service';
import {tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ViewState, toViewState} from '../../model/view-state';
import {Member} from '../../model/member';
import {HttpErrorResponse} from '@angular/common/http';
import {AsyncPipe} from '@angular/common';
import { AlertComponent } from '../shared/alert/alert.component';
import { LoaderComponent } from '../shared/loader/loader.component';
import { TranslatePipe } from '@ngx-translate/core';
import { SearchButtonComponent } from '../shared/search-button/search-button.component';

@Component({
    selector: 'myabvv-search-member',
    standalone: true,
    templateUrl: './search-member.component.html',
    imports: [AsyncPipe, AlertComponent, LoaderComponent, TranslatePipe, SearchButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchMemberComponent implements OnInit {
  private memberService = inject(MemberService);
  private router = inject(Router);
  private memberStateService = inject(MemberStateService);
  private validationService = inject(ValidationService);

  inss: string;
  errorStatus: number;
  errorMessage: string;

  searchState$: Observable<ViewState<Member>>;
  isOpenedInNewTab$: Observable<boolean>;

  ngOnInit() {
    this.isOpenedInNewTab$ = this.memberStateService.getIsOpenedInNewTabSubject();
  }

  setInss(inss: string): void {
    this.inss = inss;
    this.memberStateService.setIsOpenedInNewTabSubject(false);
  }

  searchMember(memberSsin: string) {
    if (!this.isValidInss(memberSsin)) {
      return;
    }

    memberSsin = memberSsin.replace(/[.-]/g, '');

    this.searchState$ = this.memberService.getMember(memberSsin).pipe(
      tap(member => {
        const areAllValuesNull = Object.values(member).every(value => value === null);
        if (areAllValuesNull) {
          this.setErrorMessage();
          throw new Error('MEMBER_NOT_FOUND');
        } else {
          this.memberStateService.setMember(member);
          this.router.navigate(['unemployment/recent-infos']).then().catch();
        }
      }),
      toViewState((err) => {
        if (err?.message !== 'MEMBER_NOT_FOUND') {
          this.setErrorMessage(err);
        }
        return true;
      })
    );
  }

  isValidInss(inss?: string) {
    if (!inss) {
      inss = this.inss;
    }
    return this.validationService.validateInss(inss);
  }

  searchMemberWithEnterButton() {
    if (this.isValidInss()) {
      this.searchMember(this.inss);
    }
  }

  private setErrorMessage(err?: HttpErrorResponse) {
    if (!err || err?.message === 'MEMBER_NOT_FOUND' || err.status === 404 ||
        (err.status === 500 && err.error?.moreInformation?.includes('No user found for ID'))) {
      this.errorMessage = 'SEARCH_PAGE.error.' + 404;
      this.errorStatus = 404;
    } else {
      this.errorMessage = 'SEARCH_PAGE.error.' + 500;
      this.errorStatus = 500;
    }
  }
}
